import type { ReactNode } from 'react';

export const symbol_sentiment_extremely_dissatisfied: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-83 0-156-31.5t-127-86Q143-252 111.5-325T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 155.5 31.5t127 85.5q54.5 54 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-60q141 0 240.5-99.5T820-480q0-142-99.5-241T480-820q-142 0-241 99t-99 241q0 141 99 240.5T480-140Zm140-353q23 0 38.5-15.5T674-547q0-13-5.5-24T653-590l10-5q8-4 10-11.5t-3-15.5q-5-8-12.5-10.5T642-630l-91 53q-8 5-10 13t4 19q3 6 9.5 7.5T567-539q3 20 18 33t35 13Zm-280 0q20 0 35-13t18-33q6 3 12.5 1t11.5-11q4-8 2-15.5T409-577l-92-53q-7-4-15-2.5t-12 9.5q-5 8-2.5 16t10.5 12l9 5q-10 8-15.5 19t-5.5 24q0 23 15.5 38.5T340-493Zm140 56q-69 0-121 45.5T281-280h398q-27-65-78.5-111T480-437Zm0-43Z"
		/>
	</svg>
);
